import { ODListableResponseType } from '@odc/od-react-belt'
import React from 'react'
import { GQLAppSplashImage } from '../../../@types/server'
import { useStoryPlayAPIs } from '../../../hooks/useStoryPlayAPIs'
import { IAppSplashImageListableOption } from '../AppSplashImageCommon'

export function useAppSplashImageListDataLoader() {
  const { listAppSplashImage } = useStoryPlayAPIs()
  return React.useCallback(
    async function dataLoader(
      page: number,
      pageSize: number,
      afterKey: string | null,
      options: IAppSplashImageListableOption
    ): Promise<ODListableResponseType<GQLAppSplashImage>> {
      const r = await listAppSplashImage({
        page,
        pageSize: 100,
        ...options,
      })
      return r as ODListableResponseType<GQLAppSplashImage>
    },
    [listAppSplashImage]
  )
}
